import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function UserLoading() {
    const { t } = useTranslation('main', { keyPrefix: 'login' });
    return (
        <Row fullWidth align='center'
            justify='center'
            spacing={8}
            css={css`padding: 12px  0;`} >
            <Spinner/>
            <Text size='lg' color={colors.gray6}>{t('loading')}</Text>
        </Row>
    );
}

const Spinner = styled.div`
    animation: rotation 1s linear infinite;
    border: 3px solid var(--color-primary);
    border-bottom-color: transparent;
    border-radius: 50%;
    box-sizing: border-box;
    display: inline-block;
    height: 24px;
    width: 24px;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export default UserLoading;
